export const CHECKBOX = 'checkbox';
export const RADIO = 'radio';

export function getSelectionType(variation) {
  return variation.minNumAllowed === 1 && variation.maxNumAllowed === 1 ? RADIO : CHECKBOX;
}

export function getBasicDisplayableOrderItem(item, locale, itemsHash) {
  const { count, price, itemId } = item; // tpdp masha price check?
  return { title: itemsHash[itemId].title[locale], itemId, price, count }; //todo masha
}
